'use strict';

exports.__esModule = true;
var UrlUpdateTypes = {
  replace: 'replace',
  replaceIn: 'replaceIn',
  multiReplaceIn: 'multiReplaceIn',
  push: 'push',
  pushIn: 'pushIn',
  multiPushIn: 'multiPushIn'
};

exports.default = UrlUpdateTypes;


//////////////////
// WEBPACK FOOTER
// ./~/react-url-query/lib/UrlUpdateTypes.js
// module id = 14
// module chunks = 131683993344931 142807904292071 231608221292675